import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { InputField, TextareaField } from "@teselagen/ui";
import { reduxForm } from "redux-form";
import withEditorProps from "../../withEditorProps";
import { compose } from "recompose";
import {
  EditAvailabilityItem,
  EditCircularityItem,
  EditReadOnlyItem
} from "../../StatusBar";
class GeneralProperties extends React.Component {
  updateSeqDesc = (val) => {
    return this.props.sequenceDescriptionUpdate(val);
  };
  render() {
    const {
      readOnly,
      showReadOnly = true,
      isProtein,
      disableSetReadOnly,
      sequenceData,
      onSave,
      showAvailability,
      beforeReadOnlyChange,
      editorName,
      disableBpEditing,
      sequenceNameUpdate
    } = this.props;
    const {
      description,
      name,
      isOligo,
      isRna,
      sequence = "",
      proteinSequence = ""
    } = sequenceData || {};
    return /* @__PURE__ */ jsxs(React.Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "ve-flex-row", children: [
        /* @__PURE__ */ jsx("div", { className: "ve-column-left bp3-label", children: "Name" }),
        " ",
        /* @__PURE__ */ jsxs("div", { className: "ve-column-right", children: [
          /* @__PURE__ */ jsx(
            InputField,
            {
              disabled: readOnly,
              onFieldSubmit: (val) => {
                sequenceNameUpdate(val);
              },
              name: "name",
              enableReinitialize: true,
              defaultValue: name
            }
          ),
          " "
        ] })
      ] }),
      !isProtein && !isOligo && !isRna && /* @__PURE__ */ jsxs("div", { className: "ve-flex-row circularLinearSelect", children: [
        /* @__PURE__ */ jsx("div", { className: "ve-column-left bp3-label", children: "Circular/Linear" }),
        " ",
        /* @__PURE__ */ jsxs("div", { className: "ve-column-right", children: [
          " ",
          /* @__PURE__ */ jsx(EditCircularityItem, { editorName, showCircularity: true })
        ] })
      ] }),
      showAvailability && /* @__PURE__ */ jsxs("div", { className: "ve-flex-row", children: [
        /* @__PURE__ */ jsx("div", { className: "ve-column-left bp3-label", children: "Material Availability" }),
        " ",
        /* @__PURE__ */ jsxs("div", { className: "ve-column-right", children: [
          " ",
          /* @__PURE__ */ jsx(EditAvailabilityItem, { editorName, showAvailability: true })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "ve-flex-row", children: [
        /* @__PURE__ */ jsx("div", { className: "ve-column-left bp3-label", children: "Length" }),
        " ",
        /* @__PURE__ */ jsxs("div", { className: "ve-column-right", children: [
          " ",
          isProtein ? proteinSequence.length : sequence.length
        ] })
      ] }),
      showReadOnly && /* @__PURE__ */ jsxs("div", { className: "ve-flex-row", children: [
        /* @__PURE__ */ jsx("div", { className: "ve-column-left bp3-label", children: "Is Editable" }),
        " ",
        /* @__PURE__ */ jsxs("div", { className: "ve-column-right", children: [
          " ",
          /* @__PURE__ */ jsx(
            EditReadOnlyItem,
            {
              beforeReadOnlyChange,
              editorName,
              onSave,
              disableBpEditing,
              disableSetReadOnly,
              showReadOnly
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { children: "Description" }),
      /* @__PURE__ */ jsx(
        TextareaField,
        {
          clickToEdit: true,
          name: "description",
          onFieldSubmit: this.updateSeqDesc,
          defaultValue: description,
          disabled: readOnly
        }
      )
    ] });
  }
}
export default compose(
  withEditorProps,
  reduxForm({
    form: "GeneralProperties"
  })
)(GeneralProperties);
